module.exports = __webpack_public_path__ + "static/img/pic_titliecsbj@2x.7abbc9ee.png";